import nvSdcModule from '../../nv.sdcModule.module';

angular.module(nvSdcModule).controller('gridModalCtrl', gridModalCtrl);

function gridModalCtrl($mdDialog, refreshColumns) {
  let self = this;

  self.refreshColumns = newColumns => {
    refreshColumns({ newColumns });
  };

  self.cancel = function() {
    $mdDialog.cancel('cancel');
  };
}
